<template>
  <div class="date-component" :class="{ 'date-warning': isError }">
    <date-picker
      placeholder="เลือกวันที่"
      v-model="date"
      :type="dateTime ? 'datetime' : 'date'"
      range
      lang="en"
      :format="dateTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'"
      confirm
      @confirm="onConfirm()"
      @clear="onClear()"
    />
    <span v-if="isError" class="validate-invalid" v-html="invalid"></span>
  </div>
</template>
<script>
// import utils
import { ToISOString } from '@/helpers/utils/format-date.js'
import DatePicker from 'vue2-datepicker'
export default {
  name: 'date-range',
  components: {
    DatePicker,
  },
  props: {
    default: {
      // type: [Date, String],
      // default: null
    },
    isError: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: String,
      default: '',
    },
    dateTime: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      date: [],
      dateRange: {
        from: '',
        to: '',
      },
    }
  },
  watch: {
    default: function(value) {
      this.date = value
      this.onConfirm()
    },
  },
  computed: {},
  methods: {
    onConfirm() {
      this.dateRange.from = ToISOString(new Date(this.date[0]))
      this.dateRange.to = ToISOString(new Date(this.date[1]))
      this.$emit('selected', this.dateRange)
    },
    onClear() {
      this.dateRange.from = ''
      this.dateRange.to = ''
      this.$emit('selected', this.dateRange)
    },
  },
}
</script>
